export const STableCell = {
  py: '2px'
};
